module.exports = _;


//////////////////
// WEBPACK FOOTER
// external "_"
// module id = 2
// module chunks = 1